import React, { useState } from 'react';
import { AlertCircleIcon, CheckCircle2Icon } from 'lucide-react';
export function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    preferredTime: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        preferredTime: '',
        message: ''
      });
    }, 1500);
  };
  if (status === 'success') {
    return <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center" data-id="element-9">
        <CheckCircle2Icon className="w-12 h-12 text-green-600 mx-auto mb-4" data-id="element-10" />
        <h3 className="text-lg font-semibold text-green-900 mb-2" data-id="element-11">
          Message Sent Successfully
        </h3>
        <p className="text-green-700 mb-4" data-id="element-12">
          Thank you for reaching out. A member of our team will contact you
          shortly.
        </p>
        <button onClick={() => setStatus('idle')} className="text-primary font-medium hover:underline" data-id="element-13">
          Send another message
        </button>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-5" data-id="element-14">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-15">
        <div className="space-y-1.5" data-id="element-16">
          <label htmlFor="name" className="block text-sm font-medium text-brandtext" data-id="element-17">
            Full Name
          </label>
          <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-2.5 border border-bordercolor rounded-md focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-shadow bg-surface" placeholder="Jane Doe" data-id="element-18" />
        </div>
        <div className="space-y-1.5" data-id="element-19">
          <label htmlFor="email" className="block text-sm font-medium text-brandtext" data-id="element-20">
            Email Address
          </label>
          <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-2.5 border border-bordercolor rounded-md focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-shadow bg-surface" placeholder="jane@example.com" data-id="element-21" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-22">
        <div className="space-y-1.5" data-id="element-23">
          <label htmlFor="phone" className="block text-sm font-medium text-brandtext" data-id="element-24">
            Phone Number
          </label>
          <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-2.5 border border-bordercolor rounded-md focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-shadow bg-surface" placeholder="(555) 123-4567" data-id="element-25" />
        </div>
        <div className="space-y-1.5" data-id="element-26">
          <label htmlFor="preferredTime" className="block text-sm font-medium text-brandtext" data-id="element-27">
            Preferred Contact Time
          </label>
          <input type="text" id="preferredTime" name="preferredTime" value={formData.preferredTime} onChange={handleChange} className="w-full px-4 py-2.5 border border-bordercolor rounded-md focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-shadow bg-surface" placeholder="e.g., Mornings, 2pm-4pm" data-id="element-28" />
        </div>
      </div>

      <div className="space-y-1.5" data-id="element-29">
        <label htmlFor="message" className="block text-sm font-medium text-brandtext" data-id="element-30">
          Brief Message
        </label>
        <textarea id="message" name="message" rows={4} required value={formData.message} onChange={handleChange} className="w-full px-4 py-2.5 border border-bordercolor rounded-md focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-shadow bg-surface resize-y" placeholder="How can we help you?" data-id="element-31" />
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-md p-4 flex items-start gap-3" data-id="element-32">
        <AlertCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-33" />
        <p className="text-sm text-amber-800" data-id="element-34">
          <strong data-id="element-35">Privacy Notice:</strong> Please do not include personal
          medical details, test results, or sensitive health information in this
          form.
        </p>
      </div>

      <button type="submit" disabled={status === 'submitting'} className="w-full md:w-auto px-8 py-3 bg-primary text-white font-medium rounded-md hover:bg-primary-dark transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-36">
        {status === 'submitting' ? 'Sending...' : 'Send Message'}
      </button>
    </form>;
}